<template>
    <div>
        <div class="auth-panel d-flex align-items-right">
            <img class="ul-logo" src="../assets/images/placeholders/UL_Logo.png" />
            <ul v-show="!userContent.loggedin">
                <li><a target="_blank" href="https://app.ultralibrarian.com/Account/Register">Register</a></li>
                <li>
                    <a href="#" @click="loginPanel.showLogin = true">Login</a>
                </li>
            </ul>
            <ul v-show="userContent.loggedin">
                <li>{{userContent.username}}</li>
                <li><a href="#" @click="logout()">Logout</a></li>
            </ul>
        </div>
        <transition name="modal" v-if="loginPanel.showLogin" >
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="login-modal-container modal-container">
                        <div class="modal-body-before"></div>
                        <div class="modal-body login-panel login-borders">
                            <form @submit.prevent="login(loginPanel)">
                                <img class="ul-logo align-center" src="../assets/images/placeholders/UL_Logo.png" />
                                <input name="userName" class="form-control mt-2 mb-2" type="text" placeholder="Email" v-model="loginPanel.username">
                                <input name="password" class="form-control mt-2 mb-2" type="password" placeholder="Password" v-model="loginPanel.password">
                                <div class="login-remember">
                                    <label><input name="remember" type="checkbox" v-model="loginPanel.remember" value="true"><strong>Remember Login</strong></label>
                                </div>
                                <label class="required">
                                    {{loginPanel.message}}
                                </label>
                                <div class="login-btns d-flex">
                                    <button type="submit" class="btn btn-dark mt-2">Login</button>
                                    <a class="btn btn-default mt-2" href="#" @click="loginPanel.showLogin = false">Cancel</a>
                                </div>
                                <div>
                                    <p>
                                        <a target="_blank" href="https://app.ultralibrarian.com/Account/Register">Register</a>
                                    </p>
                                    <p>
                                        <a target="_blank" href="https://app.ultralibrarian.com/Account/ForgotPassword">Forgot Password</a>
                                    </p>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: 'LoginPanel',
        data() {
            return {
                loginPanel: {
                    username: "",
                    password: "",
                    message: "",
                    remember: false,
                    showLogin: false
                }
            }
        },
        props: {
            userContent: {
                type: Object,
                default: () => {
                    return {
                        loggedin: false,
                        username: ""
                    }
                }
            }
        },
        methods: {
            login(loginPanel) {
                var loginSubmission = {
                    user_name: loginPanel.username,
                    password: loginPanel.password,
                    remember_login: loginPanel.remember
                };

                loginPanel.password = "";

                axios
                    .post('/api/v1/auth/login', loginSubmission, { crossdomain: true })
                    .then(response => {
                            //check response type, 200 means valid submission, check the result
                        //400 means bad submission read differently
                        if (response.data) {
                            this.userContent.loggedin = response.data.is_success;
                            this.userContent.username = response.data.email;
                            if (response.data.is_success) {
                                this.loginPanel.showLogin = false;
                                loginPanel.username = "";
                                this.$root.$emit('login');
                            } else {
                                this.loginPanel.message = response.data.message;
                            }
                        }
                    })
                    .catch((error) => {
                        if (error.response.data) {
                            this.loginPanel.message = 'Username and password are required';
                        }
                        this.$root.$emit('login_failed', 'error');

                    });
            },
            logout() {
                axios
                    .post('/api/v1/auth/logout', { crossdomain: true })
                    .then(() => {
                        this.userContent.loggedin = false;
                        this.userContent.username = null;
                        this.$root.$emit('logout');
                    })
                    .catch(() => {
                        this.$root.$emit('logout_failed', 'error');
                    });
            },
            refresh() {
                axios
                .get('/api/v1/auth/refresh', { crossdomain: true })
                .then(response => {
                    //check response type, 200 means valid submission, check the result
                    //400 means bad submission read differently
                    if (response.data) {
                        this.userContent.loggedin = response.data.is_success;
                        this.userContent.username = response.data.email;
                        if (response.data.is_success) {
                            this.loginPanel.showLogin = false;
                            this.$root.$emit('login');
                        }
                    }
                });
            }
        },
        mounted() {
            this.$root.$on('show_login', () => {
                this.loginPanel.showLogin = true;
            });
            this.$root.$on('login_refresh', () => {
                this.refresh();
            });
        }
    };
</script>


<style>
    .auth-panel {
        border-bottom: #c51730 2px solid;
        background-color: #fff;
    }

    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: table;
        transition: opacity 0.3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
        position: relative;
    }

    .modal-container {
        width: 400px;
        margin: 0px auto;
        padding: 10px 15px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    div.login-modal-container {
        padding: 0px;
        position: relative;
        box-shadow: 2px 2px 10px;
    }

    .login-panel {
        padding-left: 0;
        padding-right: 0;
        float: none;
        margin: auto;
    }
    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 10px 0;
        padding: 0rem 1rem;
    }

    .modal-default-button {
        display: block;
        margin-top: 1rem;
    }

        /*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

        .modal-enter {
            opacity: 0;
        }

        .modal-leave-active {
            opacity: 0;
        }

        .modal-enter .modal-container,
        .modal-leave-active .modal-container {
            -webkit-transform: scale(1.1);
            transform: scale(1.1);
        }

        .login-borders {
            border-style: solid;
            border-color: #c51730;
            border-width: 10px 0 10px 0;
        }

        .login-borders form {
            padding: 20px 5px 20px 5px;
        }

        .login-btns {
            padding-bottom: 1em;
        }

        .auth-panel ul {
            width: 100%;
            display: flex;
            flex-direction: row;
            padding: 0px;
            justify-content: flex-end;
            padding-top: 3px;
            margin: 8px 0px;
        }

        .auth-panel ul li {
            display: block;
            flex: 0 1 auto; /* Default */
            list-style-type: none;
        }

        .auth-panel ul li + li {
            padding-left: 1em;
        }

        label strong {
            padding-left: .5em;
        }

        .ul-logo {
            max-height: 40px;
            align-self: start;
            margin: 3px 0px;
        }

        .login-btns {
            display: flex;
            justify-content: space-between;
        }


    @media (min-width: 1300px ) {

        .modal-body-before {
            content: "";
            position: absolute;
            left: 0px;
            top: 0px;
            width: 250px;
            height: 403.3333px;
            background: transparent url('~@/assets/images/login/Side Graphic.png') no-repeat left top;
            background-size: 172px;
            z-index: 50;
        }

        .modal-container {
            width: 550px;
        }

        .login-panel {
            padding-left: 250px;
        }
    }
</style>